import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { AppSettings } from 'src/app/core/configs/app.settings';
import { ServiceHelper } from 'src/app/core/helper/services.helper';
import { Community } from 'src/app/data/schema/community';
import { HtmlEditorModal } from '../../modal/html-editor/html-editor.component';
import { Utilities } from 'src/app/core/helper/util';
import { Log } from 'src/app/core/log';

@Component({
  selector: 'app-text-or-html',
  templateUrl: './text-or-html.component.html',
  styleUrls: ['./text-or-html.component.scss'],
})
export class TextOrHtmlComponent implements OnInit {

  @Input() name: string = 'body';
  @Input() label: string = 'Content';
  @Input() allowLargeEditor: boolean = true;
  @Input() htmlOnly: boolean = false;
  @Input() value: string;
  @Input() isInModal: boolean = false;
  @Input() maxLength: number = 5000;
  @Input() helpText: string;

  @Output() valueChange = new EventEmitter<string>();

  useHtml: boolean;
  
  showFroala: boolean = false;

  froalaEditor: any;
  froalaOptions: any;

  onValueChange() {
    this.valueChange.emit(this.value);
  }
  
  constructor(public sanitizer: DomSanitizer) { 
    this.froalaOptions = Utilities.standardFroalaOptions(Community.activeCommunity.communityId);
  }

  async openHtmlEditor(){
    var htmlModal = await ServiceHelper.modalCtrl.create({
      component: HtmlEditorModal,
      cssClass: 'bigger-modal',
      componentProps: {
        html: this.value,
        maxLength: this.maxLength
      },
      backdropDismiss: false,
      keyboardClose: false,
    });
    await htmlModal.present();
    htmlModal.onDidDismiss().then(async e => {
      if ( e != null && e.data != null ) {
        this.value = e.data.html;
        this.valueChange.emit(this.value);
        this.useHtml = this.value != null && this.value.includes('</');
      }
    });
  }

  async ngOnInit() {
    this.useHtml = (this.value != null && this.value.includes('</')) || this.htmlOnly;

    if (this.isInModal ){
      Log.debug('modal html editor ')
      var modalContent = document.getElementById('html-modal-content');
      while (modalContent.offsetHeight == 0 ){
        await Utilities.wait(100);
      }
      this.froalaOptions.height =  modalContent.offsetHeight - 150;
    }
    this.froalaOptions.charCounterMax = this.maxLength;
    this.showFroala = true;
  }

  async initializeFroala(editor) {
    await editor.initialize();
  }

  showHelp() {
    ServiceHelper.displayAlert('', this.helpText);
  }
}
